import type { Identifier } from "ra-core";

import type { Company, Contact } from "../types";

export const getDefaultTaskAssigneeId = ({
  contact,
  company,
  identityId,
  canAssignOthers,
}: {
  contact?: Pick<Contact, "sales_id"> | null;
  company?: Pick<Company, "sales_id"> | null;
  identityId: Identifier;
  canAssignOthers: boolean;
}): Identifier => {
  if (!canAssignOthers) {
    return identityId;
  }
  return contact?.sales_id ?? company?.sales_id ?? identityId;
};
